module.exports = __webpack_public_path__ + "static/media/facebook_messenger_logo.ab213cc6.png";